import * as types from "./shared.types";

const initialState = {
	open_tab: -1,
	open_tab_item: null,
};

export default function shared_reducer(state = initialState, action) {
	switch (action.type) {
		case types.SET_THEME:
			return { ...state, theme: action.payload };

		case types.SIDE_NAV_SET_OPEN_TAB:
			return { ...state, open_tab: action.tab_id };

		case types.SIDE_NAV_SET_OPEN_TAB_ITEM:
			return { ...state, open_tab_item: action.tab_item_id };

		default:
			return state;
	}
}
